/**
 * Lazy-loaded Atlassian Web Crawler icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyWebDomainSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-atlassian-web-crawler" */ './utils').then(
			(m) => m.WebDomainSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/atlassian-web-crawler/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const WebDomainSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyWebDomainSearchResultIconComponent />
	</Suspense>
);
